// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdditionalEmailsController from "./additional_emails_controller"
application.register("additional-emails", AdditionalEmailsController)

import AddressAutocompleteController from "./address_autocomplete_controller"
application.register("address-autocomplete", AddressAutocompleteController)

import AnalyticsRefreshController from "./analytics_refresh_controller"
application.register("analytics-refresh", AnalyticsRefreshController)

import AnchorScrollController from "./anchor_scroll_controller"
application.register("anchor-scroll", AnchorScrollController)

import AutoFormatController from "./auto_format_controller"
application.register("auto-format", AutoFormatController)

import AutoRedirectController from "./auto_redirect_controller"
application.register("auto-redirect", AutoRedirectController)

import AutoReloadController from "./auto_reload_controller"
application.register("auto-reload", AutoReloadController)

import AutoScrollController from "./auto_scroll_controller"
application.register("auto-scroll", AutoScrollController)

import AutosaveController from "./autosave_controller"
application.register("autosave", AutosaveController)

import BackController from "./back_controller"
application.register("back", BackController)

import BaseUploadController from "./base_upload_controller"
application.register("base-upload", BaseUploadController)

import BatchSelectorController from "./batch_selector_controller"
application.register("batch-selector", BatchSelectorController)

import BatchStatusController from "./batch_status_controller"
application.register("batch-status", BatchStatusController)

import BookingUploadController from "./booking_upload_controller"
application.register("booking-upload", BookingUploadController)

import BulkEditItemsController from "./bulk_edit_items_controller"
application.register("bulk-edit-items", BulkEditItemsController)

import CardAnimateController from "./card_animate_controller"
application.register("card-animate", CardAnimateController)

import CategoryLoaderController from "./category_loader_controller"
application.register("category-loader", CategoryLoaderController)

import CategoryToggleController from "./category_toggle_controller"
application.register("category-toggle", CategoryToggleController)

import ChannelLoaderController from "./channel_loader_controller"
application.register("channel-loader", ChannelLoaderController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import CityAutocompleteController from "./city_autocomplete_controller"
application.register("city-autocomplete", CityAutocompleteController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import ContactImportController from "./contact_import_controller"
application.register("contact-import", ContactImportController)

import ContactSelectorController from "./contact_selector_controller"
application.register("contact-selector", ContactSelectorController)

import ContactsMapController from "./contacts_map_controller"
application.register("contacts-map", ContactsMapController)

import ConversationController from "./conversation_controller"
application.register("conversation", ConversationController)

import CountdownTimerController from "./countdown_timer_controller"
application.register("countdown-timer", CountdownTimerController)

import DimensionsController from "./dimensions_controller"
application.register("dimensions", DimensionsController)

import DirectUploadController from "./direct_upload_controller"
application.register("direct-upload", DirectUploadController)

import DiscountTypeController from "./discount_type_controller"
application.register("discount-type", DiscountTypeController)

import DiscordRoleSelectorController from "./discord_role_selector_controller"
application.register("discord-role-selector", DiscordRoleSelectorController)

import DiscordWizardController from "./discord_wizard_controller"
application.register("discord-wizard", DiscordWizardController)

import DownloadProgressController from "./download_progress_controller"
application.register("download-progress", DownloadProgressController)

import DraggableController from "./draggable_controller"
application.register("draggable", DraggableController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EditableCityController from "./editable_city_controller"
application.register("editable-city", EditableCityController)

import EnhancedFormController from "./enhanced_form_controller"
application.register("enhanced-form", EnhancedFormController)

import EventDispatcherController from "./event_dispatcher_controller"
application.register("event-dispatcher", EventDispatcherController)

import FestivalImportController from "./festival_import_controller"
application.register("festival-import", FestivalImportController)

import FestivalsMapController from "./festivals_map_controller"
application.register("festivals-map", FestivalsMapController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import FiltersToggleController from "./filters_toggle_controller"
application.register("filters-toggle", FiltersToggleController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FloatingChatController from "./floating_chat_controller"
application.register("floating-chat", FloatingChatController)

import FloatingMapController from "./floating_map_controller"
application.register("floating-map", FloatingMapController)

import FollowersChartController from "./followers_chart_controller"
application.register("followers-chart", FollowersChartController)

import FormController from "./form_controller"
application.register("form", FormController)

import GigTypeController from "./gig_type_controller"
application.register("gig-type", GigTypeController)

import GrammarCorrectionController from "./grammar_correction_controller"
application.register("grammar-correction", GrammarCorrectionController)

import GridController from "./grid_controller"
application.register("grid", GridController)

import GridFilterController from "./grid_filter_controller"
application.register("grid-filter", GridFilterController)

import GridScrollController from "./grid_scroll_controller"
application.register("grid-scroll", GridScrollController)

import HeroVideoController from "./hero_video_controller"
application.register("hero-video", HeroVideoController)

import ImageZoomController from "./image_zoom_controller"
application.register("image-zoom", ImageZoomController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import MapOverlayController from "./map_overlay_controller"
application.register("map-overlay", MapOverlayController)

import MediaGalleryController from "./media_gallery_controller"
application.register("media-gallery", MediaGalleryController)

import MediaOrganizerController from "./media_organizer_controller"
application.register("media-organizer", MediaOrganizerController)

import MediaUploadController from "./media_upload_controller"
application.register("media-upload", MediaUploadController)

import MentionsAutocompleteController from "./mentions_autocomplete_controller"
application.register("mentions-autocomplete", MentionsAutocompleteController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import ModalCloserController from "./modal_closer_controller"
application.register("modal-closer", ModalCloserController)

import NestedVenuesController from "./nested_venues_controller"
application.register("nested-venues", NestedVenuesController)

import NewItemMediaController from "./new_item_media_controller"
application.register("new-item-media", NewItemMediaController)

import ItemMediaFormController from "./item_media_form_controller"
application.register("item-media-form", ItemMediaFormController)

import ItemVariantsController from "./item_variants_controller"
application.register("item-variants", ItemVariantsController)

import NestedFieldsController from "./nested_fields_controller"
application.register("nested-fields", NestedFieldsController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import PhotoRemovalController from "./photo_removal_controller"
application.register("photo-removal", PhotoRemovalController)

import PhotoSwitchController from "./photo_switch_controller"
application.register("photo-switch", PhotoSwitchController)

import PhotoUploadController from "./photo_upload_controller"
application.register("photo-upload", PhotoUploadController)

import ProcessVideosController from "./process_videos_controller"
application.register("process-videos", ProcessVideosController)

import PromoCodeController from "./promo_code_controller"
application.register("promo-code", PromoCodeController)

import ProductFitController from "./product_fit_controller"
application.register("product-fit", ProductFitController)

import ScrollNavbarController from "./scroll_navbar_controller"
application.register("scroll-navbar", ScrollNavbarController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SearchFilterController from "./search_filter_controller"
application.register("search-filter", SearchFilterController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import ServicePointsController from "./service_points_controller"
application.register("service-points", ServicePointsController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SpinnerController from "./spinner_controller"
application.register("spinner", SpinnerController)

import StopPropagationController from "./stop_propagation_controller"
application.register("stop-propagation", StopPropagationController)

import Stores__DiscordConfigController from "./stores/discord_config_controller"
application.register("stores--discord-config", Stores__DiscordConfigController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TemplateVariablesController from "./template_variables_controller"
application.register("template-variables", TemplateVariablesController)

import TextToggleController from "./text_toggle_controller"
application.register("text-toggle", TextToggleController)

import ToggleSirenController from "./toggle_siren_controller"
application.register("toggle-siren", ToggleSirenController)

import TouringBookingFormController from "./touring_booking_form_controller"
application.register("touring-booking-form", TouringBookingFormController)

import TouringMapController from "./touring_map_controller"
application.register("touring-map", TouringMapController)

import TranslationController from "./translation_controller"
application.register("translation", TranslationController)

import TrixController from "./trix_controller"
application.register("trix", TrixController)

import Ttt__BacketPopupController from "./ttt/backet_popup_controller"
application.register("ttt--backet-popup", Ttt__BacketPopupController)

import Ttt__ImageBgController from "./ttt/image_bg_controller"
application.register("ttt--image-bg", Ttt__ImageBgController)

import Ttt__ScrollDownController from "./ttt/scroll_down_controller"
application.register("ttt--scroll-down", Ttt__ScrollDownController)

import Ttt__TController from "./ttt/t_controller"
application.register("ttt--t", Ttt__TController)

import TurboConfirmController from "./turbo_confirm_controller"
application.register("turbo-confirm", TurboConfirmController)

import TurboModalController from "./turbo_modal_controller"
application.register("turbo-modal", TurboModalController)

import UnreadMessagesDropdownController from "./unread_messages_dropdown_controller"
application.register("unread-messages-dropdown", UnreadMessagesDropdownController)

import Unsafe__ScrollController from "./unsafe/scroll_controller"
application.register("unsafe--scroll", Unsafe__ScrollController)

import UnsfNavbarController from "./unsf_navbar_controller"
application.register("unsf-navbar", UnsfNavbarController)

import UploadProgressModalController from "./upload_progress_modal_controller"
application.register("upload-progress-modal", UploadProgressModalController)

import VariantSelectorController from "./variant_selector_controller"
application.register("variant-selector", VariantSelectorController)

import VenueImportController from "./venue_import_controller"
application.register("venue-import", VenueImportController)

import VenuesMapController from "./venues_map_controller"
application.register("venues-map", VenuesMapController)

import VideoHoverController from "./video_hover_controller"
application.register("video-hover", VideoHoverController)

